import React from "react";
import { Button, Col, Modal, Row, Typography } from "antd";
import Logo from "../../../Assets/Images/Success.svg";

const { Title } = Typography;

export const SuccessModal = ({ closeModal }) => {
  return (
    <Modal
      centered
      visible
      footer={null}
      width={460}
      wrapClassName="welcomeSuccessModelPOP"
    >
      <div className="welcomeSuccessModel">
        <div className="welcomeSuccessLogo">
          <img src={Logo} alt="" />
        </div>
        <Title level={1} className="text-center">
          Success
        </Title>
        <p>
          Your data has been saved <br />
          successfully
        </p>
        <div className="text-center pt-3">
          <Button
            type="primary"
            shape="round"
            htmlType="submit"
            className=""
            onClick={closeModal}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};
